import { render, staticRenderFns } from "./FaceManagement.vue?vue&type=template&id=66f2505a&scoped=true"
import script from "./FaceManagement.vue?vue&type=script&lang=js"
export * from "./FaceManagement.vue?vue&type=script&lang=js"
import style0 from "./FaceManagement.vue?vue&type=style&index=0&id=66f2505a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f2505a",
  null
  
)

export default component.exports